import { WidgetsServicesReturnListMain } from '@/widgets/services-return-list';

export const PagesServicesReturnMain = () => <WidgetsServicesReturnListMain />;
